import { render } from "./CaseShowContent.vue?vue&type=template&id=1d609e56&scoped=true"
import script from "./CaseShowContent.vue?vue&type=script&lang=js"
export * from "./CaseShowContent.vue?vue&type=script&lang=js"

import "./CaseShowContent.vue?vue&type=style&index=0&id=1d609e56&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d609e56"]])

export default __exports__